import * as Yup from 'yup';

export const ConfirmToDeleteAccountSchema = Yup.object().shape({
    confirmPassword: Yup.string().required('Please provide your confirmation password')
});

export type ConfirmToDeleteAccountDataType = Yup.InferType<typeof ConfirmToDeleteAccountSchema>;

type InitialValues = {
    confirmPassword: string;
};

export const ConfirmToDeleteAccountInitialValues: InitialValues = {
    confirmPassword: '',
};

export interface ConfirmToDeleteAccountInterface {
    confirmPassword: string;
}
